import React, { useState, useEffect, useContext } from 'react'
import { BufferService, LoadingContext, M_CheckBox, M_InputTextField, M_StateActions, NavigateContext } from 'src/components/M_Components'
import { Tooltip } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

export default function CreateConfiguration() {
    const dispatch = useDispatch()
    const M_State = useSelector((state) => state.StateKeyValue)
    const [optionsConfiguration, setOptionsConfiguration] = useState([])
    const [dataNotification, setDataNotification] = useState(new Map())
    const [id, setId] = useState(M_State.filter(obj => obj.key === 'selectedTab')[0]?.value)
    const [templateId, setTemplateId] = useState("")
    const [operation, setOperation] = useState("")
    const [isFirstLoop, setIsFirstLoop] = useState(true)

    const bufferServiceConfiguration = new BufferService('NotificationConfig')
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const sessionKeys = ['optionsConfiguration', 'dataNotification', 'templateId', 'operation']
    const { t } = useTranslation()

    useEffect(() => {
        if (isFirstLoop) {
            ctx.setIsLoad(true)
            getSessionStorageData(id)
            setIsFirstLoop(false)
        }
        // eslint-disable-next-line 
    }, [])

    // eslint-disable-next-line 
    useEffect(() => {
        const newId = M_State.filter(obj => obj.key === 'selectedTab')[0]?.value
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    })

    useEffect(() => {
        const tempArray = []
        sessionKeys.forEach((key) => {
            tempArray.push(sessionStorageMachine(id, key, key))
        })
        dispatch(M_StateActions.addM_State({ key: id, value: tempArray }))
        // eslint-disable-next-line
    }, [id, optionsConfiguration, dataNotification, templateId, operation])

    const sessionStorageMachine = (id, key, value) => {
        let tempObj = {}
        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            tempObj = { key: `${key}`, value: (Array.from(eval(value))) }
        } else {
            // eslint-disable-next-line
            tempObj = { key: `${key}`, value: (eval(value)) }
        }
        return tempObj
    }

    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true)
        const M_StateData = M_State.filter(obj => obj.key === sessionID)[0]?.value
        if (M_StateData) {
            const tempOC = M_StateData.filter(obj => obj.key === `optionsConfiguration`)[0]?.value
            const tempDN = M_StateData.filter(obj => obj.key === `dataNotification`)[0]?.value
            const tempTI = M_StateData.filter(obj => obj.key === `templateId`)[0]?.value
            const tempOP = M_StateData.filter(obj => obj.key === `operation`)[0]?.value
            if (tempOC || tempDN || tempTI || tempOP) {
                setOptionsConfiguration(tempOC)
                setDataNotification(new Map(tempDN))
                setTemplateId(tempTI)
                setOperation(tempOP)
                ctx.setIsLoad(false)
                return
            }
        }
        getTemplate()
    }

    const getTemplate = () => {
        const getOperation = ctx.passValue.get('operation')
        const lines = ctx.passValue?.get('lines') || ""
        const getId = lines.Id
        ctx.passValue.delete('operation')
        ctx.passValue.delete('lines')
        ctx.setPassValue(new Map(ctx.passValue))
        setOperation(getOperation)
        setTemplateId(getId)

        ctx.setIsLoad(true)
        bufferServiceConfiguration.options().then((response) => {
            if (response.name === 'AxiosError') {
                ctx.toastMessages('error', response.response.data.Errors[0], '')
                return
            }
            const filteredOptions = response.filter((elem) => elem.IsHiddenEdit !== true)

            setOptionsConfiguration(filteredOptions)

            if (getOperation === 'edit') {
                bufferServiceConfiguration.getId(getId).then((response) => {
                    if (response.name === 'AxiosError') {
                        ctx.toastMessages('error', response.response.data.Errors[0], '')
                        ctx2.closeTab(id)
                        return
                    }
                    const valueDataTemplate = response
                    filteredOptions.forEach(obj => {
                        dataNotification.set(obj.Name, valueDataTemplate[obj.Name])
                    })
                    setDataNotification(new Map(dataNotification))
                })
            }
        })
        ctx.setIsLoad(false)
    }

    const notificationConfig = (event, index) => {
        const { value, type, checked } = event.target
        if (type === "checkbox") {
            dataNotification.set(index, checked)
        } else {
            dataNotification.set(index, value)
        }
        setDataNotification(new Map(dataNotification))
    }

    const submitNotification = () => {
        ctx.setIsLoad(true)
        if (operation === 'edit') {
            bufferServiceConfiguration.update(templateId, Object.fromEntries(dataNotification)).then((response) => {
                if (response.name === 'AxiosError') {
                    ctx.toastMessages("error", '', 'Error Updating Configuration')
                    return
                }
                ctx.toastMessages("success", '', 'Configuration Updated successfully')
                ctx2.closeTab(id)
                ctx.setIsLoad(false)
            })
        } else {
            bufferServiceConfiguration.post(Object.fromEntries(dataNotification)).then((response) => {
                if (response.name === 'AxiosError') {
                    ctx.toastMessages("error", '', 'Error Creating Configuration')
                    return
                }
                ctx.toastMessages("success", '', 'Configuration created successfully')
                ctx2.closeTab(id)
                ctx.setIsLoad(false)
            })
        }
    }

    return (
        <>
            <div className='backgroundForms'>
                <div className="display">
                    <div className="menuIcon">
                        <Tooltip title={t("Close")} className='iconsHeaderTable'>
                            <div className='iconsHeaderTable' onClick={() => ctx2.closeTab(id)}>
                                <i className="pi pi-arrow-left iconTable"></i>
                                <span className='labelCRUDTable'><b>{t("Close")}</b></span>
                            </div>
                        </Tooltip>
                        <Tooltip title={t("Save")}>
                            <div className='iconsHeaderTable' onClick={submitNotification}>
                                <i className="pi pi-save iconTable"></i>
                                <span className='labelCRUDTable'><b>{t("Save")}</b></span>
                            </div>
                        </Tooltip>
                    </div>
                </div>
                <div className='dividerMenu'></div>
                <div className='divDisplayFormTemplate'>
                    {optionsConfiguration.map((elem) => (
                        <div key={elem.Name}>
                            {elem.Type === 'string' ? (
                                elem.Name === 'Password' || elem.Name === 'ClientSecret' ? (
                                    <M_InputTextField
                                        type={"password"}
                                        label={elem.NormalizedName}
                                        secondColor={"var(--color-red-dark)"}
                                        required={elem.IsRequired}
                                        onChange={(e) => notificationConfig(e, elem.Name)}
                                        value={dataNotification.get(elem.Name) || ""}

                                    />
                                ) : (
                                    <M_InputTextField
                                        type={"text"}
                                        label={elem.NormalizedName}
                                        secondColor={"var(--color-red-dark)"}
                                        required={elem.IsRequired}
                                        onChange={(e) => notificationConfig(e, elem.Name)}
                                        value={dataNotification.get(elem.Name) || ""}
                                    />
                                )
                            ) : elem.Type === 'int32' ? (
                                <M_InputTextField
                                    type={"number"}
                                    label={elem.NormalizedName}
                                    secondColor={"var(--color-red-dark)"}
                                    required={elem.IsRequired}
                                    onChange={(e) => notificationConfig(e, elem.Name)}
                                    value={dataNotification.get(elem.Name) || ""}
                                />
                            ) : elem.Type === 'boolean' ? (
                                <div className='divCheckboxFormQuotes'>
                                    <M_CheckBox
                                        label={elem.NormalizedName}
                                        onChange={(e) => notificationConfig(e, elem.Name)}
                                        color={"var(--color-red-dark)"}
                                        checked={dataNotification.get(elem.Name) || false}
                                    />
                                </div>
                            ) : ""}
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
}